import $ from 'jquery'
import showModalWithRemoteUrl from './show-modal-with-remote-url.js'

$(document).on('click', '.js-open-remote-modal', showModalWithRemoteUrl)
